import { render, staticRenderFns } from "./PrintFloodDetails.vue?vue&type=template&id=382e24d6&scoped=true"
import script from "./PrintFloodDetails.vue?vue&type=script&lang=ts"
export * from "./PrintFloodDetails.vue?vue&type=script&lang=ts"
import style0 from "./PrintFloodDetails.vue?vue&type=style&index=0&id=382e24d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e24d6",
  null
  
)

export default component.exports